import classnames from 'classnames';
import { useSgBsTheme } from 'hooks/useSgBsTheme';
import { FC, useCallback } from 'react';
import type { GroupColor } from 'state/quotes/dashboard/tiles/tiles.model';

import { ActiveCircle, Circle } from './Circle';
import { mapColorToVariable } from './color';

interface ColorItemProps {
  id?: string;
  color: GroupColor;
  active?: boolean;
  diameter?: string;
  className?: string;
  onColorSelected?: (color?: GroupColor) => void;
}

export const ColorItem: FC<ColorItemProps> = ({ id, color, active, className, diameter = '20px', onColorSelected }) => {
  const theme = useSgBsTheme();
  const colorName = mapColorToVariable(theme, color);
  const CircleComponent = active ? ActiveCircle : Circle;

  const onClick = useCallback(() => {
    if (onColorSelected) {
      onColorSelected(active ? undefined : color);
    }
  }, [active, color, onColorSelected]);

  return (
    <CircleComponent
      id={id}
      $colorName={colorName}
      className={classnames(className, { active: active })}
      $diameter={diameter}
      onClick={onClick}
      data-e2e={`color-item-${color}`}
    />
  );
};
